import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import db, { auth } from "../firebase";
import Nav from "../Nav";
import "./ProfileScreen.css";
function Profile() {
  const user = useSelector(selectUser);
  const [userRealizeDate, setUserRealizeDate] = useState("");
  const [dimondProduct, setDimondProduct] = useState(null);
  const [goldProduct, setGoldProduct] = useState(null);
  const [premiumProduct, setPremiumProduct] = useState(null);

  // every time user changed
  useEffect(() => {
    // desable button if user alredy buyed plan and check user
    const addvalue = async () => {
      await db
        .collection("users")
        .doc(user.uid)
        .get()
        .then((snapshot) => {
          const userInfo = snapshot.data();
          const Dimondplan = userInfo.DimondPlan;
          const Goldplan = userInfo.GoldPlan;
          const Premiumplan = userInfo.PremiumPlan;
          setUserRealizeDate(userInfo.timeStamp);
          if (Dimondplan === "active") {
            setDimondProduct("active");
          }
          if (Goldplan === "active") {
            setGoldProduct("active");
          }
          if (Premiumplan === "active") {
            setPremiumProduct("active");
          } else {
            alert("Buy Plans.");
          }
        });
    };
    addvalue();
  }, [user]);

  const randomProductId = () => {
    const random = Math.floor(Math.random() * 909000924);
    return random.toString();
  };

  const dimondPurchase = () => {
    const path = "https://uat.esewa.com.np/epay/main";
    let params = {
      amt: 500,
      psc: 0,
      pdc: 0,
      txAmt: 0,
      tAmt: 500,
      pid: `grempeyDimond${randomProductId()}`,
      scd: "EPAYTEST",
      su: "http://localhost:3000/pyament?q=su",
      fu: "http://localhost:3000/faild?q=fu",
    };
    function post() {
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();
    }
    post();
  };
  const goldPurchase = () => {
    const path = "https://uat.esewa.com.np/epay/main";
    let params = {
      amt: 500,
      psc: 0,
      pdc: 0,
      txAmt: 0,
      tAmt: 500,
      pid: `grempeyGold${randomProductId()}`,
      scd: "EPAYTEST",
      su: "http://localhost:3000/pyament?q=su",
      fu: "http://localhost:3000/faild?q=fu",
    };
    function post() {
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();
    }
    post();
  };
  const premiumPurchase = () => {
    const path = "https://uat.esewa.com.np/epay/main";
    let params = {
      amt: 500,
      psc: 0,
      pdc: 0,
      txAmt: 0,
      tAmt: 500,
      pid: `grempeyPremium${randomProductId()}`,
      scd: "EPAYTEST",
      su: "http://localhost:3000/pyament?q=su",
      fu: "http://localhost:3000/faild?q=fu",
    };
    function post() {
      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
      document.body.appendChild(form);
      form.submit();
    }
    post();
  };

  return (
    <div className="profilescreen">
      <Nav />
      <div className="profilescreen-body">
        <h1>Edit Profile</h1>
        <div className="profilescreen-info">
          <img
            src="https://img.pngio.com/bakugou-transparent-edit-by-n-ightstream-on-deviantart-bakugou-transparent-473_514.png"
            alt=""
          />
          <div className="profilescreen-info-info">
            <h2>{user.email}</h2>
            <h5>
              user current plan : {dimondProduct ? "Dimond," : ""}{" "}
              {goldProduct ? "Gold," : ""} {premiumProduct ? "Premium," : ""}{" "}
            </h5>
            <p>Realize date : {userRealizeDate} </p>
            <div className="userplan">
              <div>
                <h3>Netflix Dimond</h3>
                <h6>NPR.2500</h6>
                <h3>Netflix Gold</h3>
                <h6>NPR.1500</h6>
                <h3>Netflix Premium</h3>
                <h6>NPR.500</h6>
              </div>
              <div>
                <button
                  disabled={dimondProduct ? "desable" : ""}
                  onClick={dimondPurchase}
                >
                  {dimondProduct ? "Suscribed" : "Subcribe"}
                </button>
                <button
                  disabled={goldProduct ? "desable" : ""}
                  onClick={goldPurchase}
                >
                  {goldProduct ? "Suscribed" : "Subcribe"}
                </button>
                <button
                  disabled={premiumProduct ? "desable" : ""}
                  onClick={premiumPurchase}
                >
                  {premiumProduct ? "Suscribed" : "Subcribe"}
                </button>
              </div>
            </div>
            <button onClick={() => auth.signOut()}>Sing Out</button>
          </div>
        </div>
      </div>
      <div className="profilescreen-pack-info">
        <h4>Dimond</h4>
        <p> Features : Acces To Ultra HD + 4K, Events participent. </p>
        <h4>Gold</h4>
        <p> Features : Acces To 1080p + HD, No Events participent. </p>
        <h4>Premium</h4>
        <p> Features : Acces To 480p, No Events participent. </p>
      </div>
    </div>
  );
}

export default Profile;
